import React, { PureComponent } from 'react';

const iconStyle = {
  fontSize: '30px',
};

class ScrollTopButton extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };

    this.navPositionFix = this.navPositionFix.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.navPositionFix);
  }

  navPositionFix() {
    this.scrollPosition = window.scrollY;
    if (this.scrollPosition > 400) {
      this.setState(() => ({ visible: true }));
    } else {
      this.setState(() => ({ visible: false }));
    }
  }

  handleOnClick() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  render() {
    const { visible } = this.state;
    return visible ? (
      <button onClick={this.handleOnClick} className="scroll-top" title="POWRÓT NA GÓRĘ STRONY">
        <span style={iconStyle} className="template-arrow-up" />
      </button>
    ) : null;
  }
}

export default ScrollTopButton;



// WEBPACK FOOTER //
// ./src/components/ScrollTopButton.js